import { render, staticRenderFns } from "./RequestsList.vue?vue&type=template&id=c4e5c3ee&scoped=true"
import script from "./RequestsList.vue?vue&type=script&lang=js"
export * from "./RequestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e5c3ee",
  null
  
)

export default component.exports